import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', loadChildren: () => import('./public-pages/public-pages.module').then(m => m.PublicPagesModule) },
  { path: 'app', loadChildren: () => import('./private-pages/private-pages.module').then(m => m.PrivatePagesModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
